import { useDispatch } from 'react-redux'

import { agentApi } from '@api/agent'
import { userApi } from '@api/authentication'
import { bedConfigApi } from '@api/bed-config'
import { brochureApi } from '@api/brochure'
import { buildingApi } from '@api/building'
import { clearCacheApi } from '@api/clear-cache'
import { configApi } from '@api/config'
import { externalLinksApi } from '@api/external-links'
import { externalViewsApi } from '@api/external-views'
import { floorPlateGalleryApi } from '@api/floor-plate-gallery'
import { galleryApi } from '@api/gallery'
import { houseAndLandApi } from '@api/houseAndLand'
import { interactiveMapApi } from '@api/interactive-map'
import { interactivePlanApi } from '@api/interactive-plan'
import { locationApi } from '@api/location'
import { masterKeyApi } from '@api/master-key'
import { panoramicApi } from '@api/panoramic'
import { projectListApi } from '@api/project-list'
import { shortlistedApi } from '@api/shortlisted'
import { showcaseRoomApi } from '@api/showcase-room'
import { teamApi } from '@api/team'
import { unitGalleryApi } from '@api/unit-gallery'
import { videoGalleryApi } from '@api/video-gallery'
import { visionApi } from '@api/vision'
import { whiteLabelApi } from '@api/white-label'

import { removeOfflineResponseFromLocalStorage } from './offline-handler-util'

const ResetUtil = () => {
  const dispatch = useDispatch()

  const resetLocalStorage = () => {
    localStorage.removeItem('whiteLabelApiData')
    removeOfflineResponseFromLocalStorage()
  }

  const resetAllApiState = () => {
    dispatch(agentApi.util.resetApiState())
    dispatch(userApi.util.resetApiState())
    dispatch(bedConfigApi.util.resetApiState())
    dispatch(brochureApi.util.resetApiState())
    dispatch(buildingApi.util.resetApiState())
    dispatch(clearCacheApi.util.resetApiState())
    dispatch(configApi.util.resetApiState())
    dispatch(externalLinksApi.util.resetApiState())
    dispatch(externalViewsApi.util.resetApiState())
    dispatch(floorPlateGalleryApi.util.resetApiState())
    dispatch(galleryApi.util.resetApiState())
    dispatch(houseAndLandApi.util.resetApiState())
    dispatch(interactiveMapApi.util.resetApiState())
    dispatch(interactivePlanApi.util.resetApiState())
    dispatch(locationApi.util.resetApiState())
    dispatch(masterKeyApi.util.resetApiState())
    dispatch(panoramicApi.util.resetApiState())
    dispatch(projectListApi.util.resetApiState())
    dispatch(shortlistedApi.util.resetApiState())
    dispatch(showcaseRoomApi.util.resetApiState())
    dispatch(teamApi.util.resetApiState())
    dispatch(unitGalleryApi.util.resetApiState())
    dispatch(videoGalleryApi.util.resetApiState())
    dispatch(visionApi.util.resetApiState())
    dispatch(whiteLabelApi.util.resetApiState())
  }

  return {
    resetLocalStorage,
    resetAllApiState,
  }
}

export default ResetUtil
